import { EdsEntityUniqueFields } from '@/domains/milestones/types/EdsEntityUniqueFields';
import { RootState } from '@/store/types/RootState';
import { EdsEntityCodes } from '@/features/eds/enums/EdsEntityCodes';
import { getKeyByUniqueFields } from '@/domains/milestones/utils/getKeyByUniqueFields';

export const selectMilestoneRelatedEntityList = (state: RootState) => state.milestones.milestoneRelatedEntityList;
export const selectMilestoneRelatedEntityListIsLoading = (state: RootState) => state.milestones.isLoading;
export const selectRequestedItemDeletionIsLoading = (state: RootState) => state.milestones.deletionInProgress;
export const selectRequestedItemUpdatingIsLoading = (state: RootState) => state.milestones.updatingInProgress;
export const selectMilestoneRelatedEntityByUniqueKey =
  ({ id, entityName }: EdsEntityUniqueFields) =>
  (state: RootState) =>
    state.milestones.entityDetailsList[getKeyByUniqueFields({ id, entityName })];
export const selectMilestoneRelatedEntityIsLoadingByUniqueKey =
  ({ id, entityName }: EdsEntityUniqueFields) =>
  (state: RootState) =>
    state.milestones.entityDetailsLoadingStateList[getKeyByUniqueFields({ id, entityName })];

export const selectMilestoneWithCategoryOptions =
  (entityType?: EdsEntityCodes, entityId?: string) => (state: RootState) =>
    (state.milestones.milestoneCategoryOptions[entityType || ''] || {})[entityId] || [];

export const selectIsMilestoneOptionsLoading = (state: RootState) => state.milestones.isMilestoneOptionsLoading;
export const selectMilestoneValidationStyle = (state: RootState) =>
  state.milestones.milestoneValidationResult.resultedValidationStyle;
export const selectNotValidRequestedItems = (state: RootState) =>
  state.milestones.milestoneValidationResult.notValidRequestedItems;
export const selectNotValidTasks = (state: RootState) => state.milestones.milestoneValidationResult.notValidTasks;
export const selectValidationMessage = (state: RootState) =>
  state.milestones.milestoneValidationResult?.validationMessage;
export const selectNotValidRequestedItemsData = (state: RootState) => state.milestones.notValidRequestedItemsData;
export const selectNotValidTasksData = (state: RootState) => state.milestones.notValidTasksData;

export const selectIsAllAvailableMilestonesLoading = (state: RootState) =>
  state.milestones.isAvaliableMilestonesLoading;
export const selectEntityTypeAvailableMilestones = (entityType?: EdsEntityCodes) => (state: RootState) =>
  entityType ? state.milestones.allAvailableMilestones[entityType] : [];

export const selectIsNotValidContentLoading = (state: RootState) =>
  state.milestones.isNotValidRequestedItemsLoading || state.milestones.isNotValidTasksLoading;
export const selectNotValidCustomRequestedItems = (entityType, entityId) => (state: RootState) =>
  state.milestones.notValidCustomRequestedItems[`${entityType}-${entityId}`];
export const selectIsNextMilestonePossible = (entityType: string, entityId: string) => (state: RootState) =>
  state.milestones.isNextMilestonePossible[`${entityType}-${entityId}`] ?? true;
